<template>
  <div>
    <a v-for="(a,i) in attach" :key="i" target="_blank" @click="getFile(a)" class="target">{{ getAttachType(a) }} |</a>
    <!-- <img :src="img" style="width:100px;height:100px;"> -->
    <template v-if="attach.length == 0">
      <span>Doc.</span>
    </template>
  </div>
</template>
<script>
import { GetUrl } from "@/api/branchBillOflading.js";
import imexReport from '../../../views/userActions/imex-report.vue';
export default {
  components: { imexReport },
  props: {
    attach: {
      type: Array,
      required: true,
    },
    houseNo: {
      type: String,
      required: true,
    }
  },
  data () {
    return {
      attachFiles: {},
      img: ''
    }
  },
  mounted () {
    console.log("name");
    console.log(this.imgUrl)
    /*  getHouseNoAttachFiles({ houseNo: this.houseNo }).then((res) => {
       if (res.data) {
         this.attach = res.data;
       }
     }); */
  },
  methods: {
    getAttachType (name) {
      console.log("name");
      console.log(name);
      return name.lastIndexOf(".jpg") > 0 || name.lastIndexOf(".png") > 0 || name.lastIndexOf(".pdf") > 0
        ? "Doc"
        : "Doc";
    },
    async getFile (name) {
      var self = this;
      var fileRes = await GetUrl({
        name: name,
        content: this.houseNo
      });
      if (fileRes != null) {
        // self.attachFiles = self.imgUrl + fileRes.data;
        self.img = self.imgUrl + fileRes.data;
        // console.log(self.imgUrl);
        // console.log(fileRes.data);
        // let target = this.$refs.target
        // target.setAttribute('href', location.origin + self.img)
        // target.click()
        window.open(self.img);
        //this.img = fileRes.data.fileContents;
      }
    }
  },
};
</script>
<style>
</style>